import { actionTypes } from '@/core/constants'
import api from '@/core/apiclient/configuracao/tipo-modelo-documento/TipoModeloDocumentoApiClient'
import { FiltroUtils } from '@/core/utils'

export default {
	async [actionTypes.CONFIGURACAO.TIPO_MODELO_DOCUMENTO.BUSCAR_TIPOS_MODELO_DOCUMENTOS_ATIVOS]({ state }, filtro) {
		FiltroUtils.setarFiltro(state.filtro, filtro)
		return api.buscarTiposModelosDocumentosAtivos(state.filtro)
	},

	async [actionTypes.CONFIGURACAO.TIPO_MODELO_DOCUMENTO.BUSCAR_TIPOS_MODELO_DOCUMENTO_LISTAGEM_PAGINADA]({ state }) {
		const { paginacaoListagem, filtroListagem } = state
		return api.buscarTiposModeloDocumentoListagemPaginada(paginacaoListagem, filtroListagem)
	},

	async [actionTypes.CONFIGURACAO.TIPO_MODELO_DOCUMENTO.CRIAR_TIPO_DOCUMENTO](context, tipoDocumento) {
		const { data } = await api.criarTipoDocumento(tipoDocumento)

		return data
	},

	async [actionTypes.CONFIGURACAO.TIPO_MODELO_DOCUMENTO.EXCLUIR_TIPO_DOCUMENTO](context, idTipoDocumento) {
		await api.excluirTipoDocumento(idTipoDocumento)
	},

	async [actionTypes.CONFIGURACAO.TIPO_MODELO_DOCUMENTO.EDITAR_TIPO_DOCUMENTO](context, tipoDocumento) {
		const { data } = await api.editarTipoDocumento(tipoDocumento)
		return data
	},

	async [actionTypes.CONFIGURACAO.TIPO_MODELO_DOCUMENTO.BUSCAR_VALIDACOES_TRAMITACAO](context, idTipoDocumento) {
		return api.buscarValidacoesTramitacao(idTipoDocumento)
	},

	async [actionTypes.CONFIGURACAO.TIPO_MODELO_DOCUMENTO.CRIAR_VALIDACAO_TRAMITACAO](context, payload) {
		const { data } = await api.criarValidacaoTramitacao(payload)
		return data
	},

	async [actionTypes.CONFIGURACAO.TIPO_MODELO_DOCUMENTO.EDITAR_VALIDACAO_TRAMITACAO](context, payload) {
		const { data } = await api.editarValidacaoTramitacao(payload)
		return data
	},

	async [actionTypes.CONFIGURACAO.TIPO_MODELO_DOCUMENTO.EXCLUIR_VALIDACAO_TRAMITACAO](context, payload) {
		await api.excluirValidacaoTramitacao(payload)
	},
}
